var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap container-fluid vertical-spacing"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs"},[(_vm.breadcrumbs.length)?_c('SfBreadcrumbs',{attrs:{"breadcrumbs":_vm.breadcrumbs}}):_vm._e()],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }